import React, { useState, useEffect } from 'react';
import Header from "./templates/header";
import LeftBar from "./templates/left_bar";
import Loader from '../common/Loader'
import ApiService from "../../services/api.service";
import { Grid } from "@mui/material";
import { gridSpacing } from "../../store/constants";
import TotalIncomeLightCardComponent from "../common/AdminDashboard/TotalIncomeLightCardComponent";
import FilterComponent from '../common/AdminDashboard/FilterComponent';
import TitleBar from '../common/AdminDashboard/TitleBar';
import BreadCrumbsBar from '../common/AdminDashboard/BreadCrumbsBar';
import { Box } from '@mui/material';
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from 'react-redux';
import {
    DataGrid,
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarExport,
    GridToolbarDensitySelector,
} from '@mui/x-data-grid';

const ServiceDetails = () => {
    const location = useLocation()
    const [loader, showLoader] = useState(false);
    const [startDate, setStartDate] = useState(location.state?.startDate );
    const [endDate, setEndDate] = useState(location.state?.endDate);
    const [subCounty, setSubCounty] = useState("");
    const [serviceType, setServiceType] = useState(location.state?.type);
    const [totalSpent, setTotalSpent] = useState(location.state?.totalSpent);
    const [isLoading, setLoading] = useState(true);
    const [tableData, setTableData] = useState({});
    const [subTallyData, setTallyData] = useState([]);
    const navigate = useNavigate()
    const filters = useSelector(state => state.dashboardFilters)
 
    const getDatatableData = () => {
        return new Promise((resolve, reject) => {
            try {
                const payload = {

                    "type": serviceType ? (serviceType === "All" ? "" : serviceType) : "",
                    "startDate": startDate  ? startDate : "",
                    "endDate": endDate  ? endDate : "",
                    "subcountyName": subCounty ? (subCounty === "All" ? "" : subCounty) : ""
                };
                const uniqueTransactionIds = {};
                showLoader(true);
                let uri = "/farmer/transactions_subcounty_type_aggregated";
                ApiService.post(uri, payload).subscribe((res) => {
                    if (res.data !== undefined && res.data !== null) {
                        showLoader(false);
                        const uniqueData = res.data ? res.data.filter(item => {
                            if (!uniqueTransactionIds[item.TRANSACTION_ID]) {
                                uniqueTransactionIds[item.TRANSACTION_ID] = true;
                                return true;
                            }
                            return false;
                        }) : [];

                        const totalTransactionAmt = res.data ? res.data.reduce((total, item) => {
                            return total + item.TRANSACTION_AMOUNT;
                        }, 0) : 0;
                        
                        setTotalSpent(totalTransactionAmt);
                        resolve(uniqueData);
                    } else {
                        showLoader(false);
                        reject("No data found");
                    }
                });
            } catch (e) {
                showLoader(false);
                reject(e);
            }
        });
    };
    // alert("-------->>" +JSON.stringify(location.state.startDate))

    useEffect(() => {
        setLoading(true);
        const fetchData = async () => {
            try {
                const [DatatableData] = await Promise.all([getDatatableData()]);
                let dt = {
                    columns: [
                        {
                            "field": "SUBCOUNTY_NAME",
                            "headerName": "Sub-county",
                            "width": 180,
                            "editable": false
                        },
                        {
                            "field": "TYPE",
                            "headerName": "Services",
                            "width": 110
                        },
                        {
                            "field": "PRODUCT",
                            "headerName": "Service Type",
                            "width": 210
                        },
                        {
                            "field": "ITEM_QUANTITY",
                            "headerName": "Number",
                            "width": 110
                        },
                        {
                            "field": "TRANSACTION_AMOUNT",
                            "headerName": "Total Spend",
                            "width": 150,
                            "editable": false
                        },
                        {
                            "field": "TRANSACTION_ID",
                            "hide": true
                        },
                     
                    ],
                    rows: DatatableData,
                    initialState: {
                        "columns": {
                            "columnVisibilityModel": {
                                "TRANSACTION_ID": false
                            }
                        }
                    }
                }
                setTableData(dt)
                setLoading(false);
            } catch (error) {
                console.error('Error fetching data: --------------->>', error);
                setLoading(false);
            }
        };
        fetchData();
    }, [endDate, serviceType]);

    useEffect(() => {
        setLoading(true);
        const fetchData = async () => {
            try {
                const [DatatableData] = await Promise.all([getDatatableData()]);
                let dt = {
                    columns: [
                        {
                            "field": "SUBCOUNTY_NAME",
                            "headerName": "Sub-county",
                            "width": 180,
                            "editable": false
                        },
                        {
                            "field": "TYPE",
                            "headerName": "Services",
                            "width": 110
                        },
                        {
                            "field": "PRODUCT",
                            "headerName": "Service Type",
                            "width": 210
                        },
                        {
                            "field": "ITEM_QUANTITY",
                            "headerName": "Number",
                            "width": 110
                        },
                        {
                            "field": "TRANSACTION_AMOUNT",
                            "headerName": "Total Spend",
                            "width": 150,
                            "editable": false
                        },
                        {
                            "field": "TRANSACTION_ID",
                            "hide": true
                        },
                     
                    ],
                    rows: DatatableData,
                    initialState: {
                        "columns": {
                            "columnVisibilityModel": {
                                "TRANSACTION_ID": false
                            }
                        }
                    }
                }
                setTableData(dt)
                setLoading(false);
            } catch (error) {
                console.error('Error fetching data: --------------->>', error);
                setLoading(false);
            }
        };
        fetchData();
    }, [subCounty]);

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector
                    slotProps={{ tooltip: { title: 'Change density' } }}
                />
                <Box sx={{ flexGrow: 1 }} />
                <GridToolbarExport
                    slotProps={{
                        tooltip: { title: 'Export data' },
                        button: { variant: 'outlined' },
                    }}
                />
            </GridToolbarContainer>
        );
    }
    return (
        <>
            <div className="home_landing">
                <Header />
                <div className="home_app">
                    <LeftBar />
                    <div className="home_data_template_preset">
                        <div className="verify">
                            <Loader loader={loader} />
                            <div className="verify_wrapper">
                                <Grid container spacing={gridSpacing}>
                                    <Grid item sm={12} xs={12} md={12} lg={12}>
                                        <TitleBar isLoading={isLoading} />
                                    </Grid>
                                    <Grid item sm={12} xs={12} md={12} lg={12}>
                                        <BreadCrumbsBar isLoading={isLoading} navigate={navigate} />
                                    </Grid>

                                    <Grid item sm={12} xs={12} md={12} lg={12}>
                                        <FilterComponent setEndDate={setEndDate}  setStartDate={setStartDate} setSubCounty={setSubCounty} setServiceType={setServiceType} />
                                    </Grid>

                                    <Grid item sm={12} xs={12} md={12} lg={12}>
                                        {/* <TotalIncomeLightCard isLoading={isLoading} startDate={startDate} endDate={endDate} subTallyData={subTallyData} /> */}
                                        <TotalIncomeLightCardComponent isLoading={isLoading} startDate={startDate} endDate={endDate} subTallyData={subTallyData} totalSpent={totalSpent} />
                                        
                                    </Grid>



                                    {/* totalSpent */}

                                    <Grid item sm={12} xs={12} md={12} lg={12}>
                                        <div style={{ height: 400, width: '100%' }}>
                                            {
                                                (tableData && Object.keys(tableData).length !== 0) ?
                                                    <DataGrid
                                                        getRowId={(row) => row.TRANSACTION_ID}
                                                        {...tableData}
                                                        slots={{
                                                            toolbar: CustomToolbar,
                                                        }}
                                                    />
                                                    : <></>
                                            }
                                        </div>
                                    </Grid>
                                </Grid>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    );
}

export default ServiceDetails;

